import React, { useEffect, useState } from "react";
import { NavigationalButtons } from "./CreateAudioWizard";
import { Form, Formik } from "formik";
import useAxios from "axios-hooks";

import TextField from "../../../../Forms/TextField";
import UploadButton from "../../../../Forms/UploadButton";

import { useFormikContext } from "formik";

const ImageStep = ({ audioId, nextOnClick, prevOnClick, audio}) => {
    const [{ loading: submitting }, postForm] = useAxios(
        {
            url: `resources/audio/${audioId}/images`,
            method: "put",
        },
        { manual: true }
    );


    return (
        <div>
            <Formik
                initialValues={{ standardThumbnailURL: audio.standardThumbnailURL, standardThumbnailAltText: audio.standardThumbnailAltText, largeBannerUrl: audio.largeBannerUrl, largeBannerAltText: audio.largeBannerAltText }}
                isInitialValid={false}
                onSubmit={async (values) => {

                    const result = await postForm({ data: values });
                    
                    if (!result.isAxiosError) {
                        nextOnClick();
                    }
                }}
            >
                {({  }) => {
                    return (
                        <Form>
                            <ImageStepForm prevOnClick={prevOnClick} submitting={submitting} audioId={audioId} />
                        </Form>
                    )
                }}
            </Formik>
        </div>
    );
};


const ImageStepForm = ({prevOnClick, submitting, audioId}) => {
    const { setFieldValue, getFieldProps } = useFormikContext();

    const [{data}, postImage] = useAxios(
        { url: `resources/audio/upload-image`, method: "post", headers: { 'content-type': 'multipart/form-data' }},
        { manual: true },
        );

    const uploadImage = (file, size) => {
        const data = new FormData();
        data.append('Image', file);
        data.append('AudioId', audioId);
        data.append('ImageSize', size);
        return postImage({data})
    }

    return (<>
                    <TextField
                    label="Standard Thumbnail"
                    name="standardThumbnailURL"
                    className="mt-0"
                    required
                    />
                    <UploadButton name="thumbnailUrlUploader" accept="image/*" label="Upload Image" 
                    onChange={async (e) => { 
                        if (e.target.value) {
                            const fileName = e.target.files[0].name;
                            uploadImage(e.target.files[0], 'thumbnail')
                            .then( (res) => {
                                setFieldValue(`standardThumbnailURL`, fileName.replaceAll(' ', ''));
                            })
                        }
                     }}/>

                   <TextField
                    label="Alt Text"
                    name="standardThumbnailAltText"
                    className="mt-0"
                    required
                    />

                    <TextField
                    label="Large Banner"
                    name="largeBannerUrl"
                    className="mt-0"
                    required
                    />
                    <UploadButton name="largeBannerUrlUploader" accept="image/*" label="Upload Image" 
                      onChange={async (e) => { 
                        if (e.target.value) {
                            const url = e.target.files[0].name;
                            uploadImage(e.target.files[0], 'banner')
                            .then( (res) => {
                                setFieldValue(`largeBannerUrl`, url);
                            })
                        }
                    }}/>

                   <TextField
                    label="Alt Text"
                    name="largeBannerAltText"
                    className="mt-0"
                    required
                    />

                    <NavigationalButtons
                        loading={submitting}
                        onNextProps={{ type: "submit", text: "Save and Continue" }}
                        onPrevHandler={prevOnClick}
                    />
                    </>
    )
}


export default ImageStep;
